/**
 * How a service device is named on screen, the same in every list and dialog.
 *
 * The office's number first, when it gave one — "Т-07" is what is written on the sticker and
 * what somebody looks for in the drawer — then what the device said it was. With neither, the
 * kind, so a row is never blank.
 */

type Translate = (key: string, options?: Record<string, unknown>) => string;

interface Named {
  label?: string | null;
  name?: string | null;
  kind?: string;
}

export function deviceTitle(t: Translate, device: Named): string {
  const label = device.label?.trim() || null;
  const name = device.name?.trim() || null;

  if (label !== null && name !== null) return `${label} · ${name}`;

  return label ?? name ?? t(device.kind === 'Tablet' ? 'devices.kind.Tablet' : 'devices.unnamed');
}
